export default {
  userId: "",
  localhostUrl: "",
  clickid: "",
  orderId: "",
  pathName: "",
  yzm:'',
  dyClickid: null
};
